import Units from "../../../utils/Units";
import Percentage from "../axes/Percentage";
import Time from "../axes/Time";

let Humidity = {
    type: "line",
    label: "Humidity",
    fill: true,
    lineTension: 0,
    colorPalette: 0,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Percentage,
    xAxis:Time
};

export default Humidity;



// WEBPACK FOOTER //
// ./src/components/chart/channels/Humidity.js